(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product"]) return;
  try {
    

  $( '#slideshow' )

    .slick(

      {

        slidesToScroll : 1,

        slidesToShow : 1,

        arrows : false

      }

    );


  } catch(e) { console.error(e); }
})();

})();
